import React from 'react';
import './App.css';
import Portfolio from './portfolio/Portfolio';

export default function App() {
  return <Portfolio />;
}
